import SupplierForm from "../components/SupplierForm";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import { Stack } from "@mui/material";
import { DEFAULT_TAX_SCHEME } from "../../../constants/defaults";
import { useNavigate } from "react-router-dom";
import { useMutateSupplierHandler } from "../dataHandlers/mutateSupplierHandler";
import { useState, useEffect } from "react";
import {showSnackbar} from "../../../api/snackbarSlice";
import {useDispatch} from "react-redux";
import {usePermissions} from "../../../hooks/usePermissions";
import {CREATE_SUPPLIER} from "../../../constants/eInvoicePermissions";
import {useActionDeniedSnackbar} from "../../../hooks/useActionDeniedSnackbar";

const initialData = {
  scheme_agency_id: "",
  company_id: "",
  endpoint_scheme_id: null,
  endpoint_id: "",
  party_tax_scheme: {
    tax_scheme: DEFAULT_TAX_SCHEME,
    company_id: "",
  },
  telephone: "",
  postal_address: {
    street_name: "",
    additional_street_name: "",
    address_line: "",
    city_name: "",
    country_subentity: "",
    country_code: null,
    postal_zone: "",
    country: "",
  },
  email: "",
  party_name_in_local_language: "",
  party_name: "",
  name: "",
};

export default function CreateSuppliersPage() {
  useDocumentTitle("New Supplier Form");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, hasEInvoicePermission } = usePermissions();
  const showActionDeniedSnackbar = useActionDeniedSnackbar();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSupplierCreated = () => {
    navigate("/suppliers");
  };

  const { onSubmit, error, isPending } = useMutateSupplierHandler({
    onSuccess: onSupplierCreated,
  });

  useEffect(() => {
    if (loading) {
      return;
    }
    if (!hasEInvoicePermission(CREATE_SUPPLIER)) {
      showActionDeniedSnackbar();
      navigate('/suppliers', { replace: true });
    }
  }, [loading, hasEInvoicePermission, showActionDeniedSnackbar, navigate]);

  // Reset isSubmitting when mutation completes
  useEffect(() => {
    if (!isPending && isSubmitting) {
      setIsSubmitting(false);
    }
  }, [isPending, isSubmitting]);

  const handleSubmit = async (payload) => {
    setIsSubmitting(true);
    onSubmit(payload, false);
  };

  const handleCancel = async () => navigate("/suppliers");

  return (
    <Stack direction="column" sx={{ mt: "-2rem" }}>
      <SupplierForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        initialData={initialData}
        apiErrors={error}
        isLoading={isPending || isSubmitting}
      ></SupplierForm>
    </Stack>
  );
}
